export default {
  1: 'event_pending',
  2: 'event_Accepted',
  3: 'event_Rejected',
}
